<div class="modal-header">
  <h4 class="modal-title">Quick Add Dates</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">

  <div class="form-group">
    <label for="numDatesToAdd">Number of Dates to Add</label>
    <input type="number" class="form-control"
           id="numDatesToAdd" name="numDatesToAdd"
           min="1" max="400" step="1" required
           [(ngModel)]="numDatesToAdd">
  </div>

  <div class="form-group">
    <label for="intervalSelect">Interval</label>
    <select class="custom-select"
            name="intervalSelect" id="intervalSelect"
            [(ngModel)]="interval">
      <option [ngValue]="Interval.daily">Daily</option>
      <option [ngValue]="Interval.weekly">Weekly</option>
      <option [ngValue]="Interval.biweekly">Biweekly</option>
      <option [ngValue]="Interval.monthly">Monthly</option>
    </select>
  </div>

  <div class="form-group">
    <label for="firstDate">First Date</label>
    <app-date-picker [id]="'firstDate'"
                     [(content)]="firstDate"></app-date-picker>
  </div>

  <div class="form-group">
    <label for="startTime">Start Time</label>
    <input type="time" class="form-control"
           id="startTime" name="startTime"
           step="60" required
           [(ngModel)]="startTime">
  </div>

  <div class="form-group">
    <label for="durationMinutes">Duration (minutes)</label>
    <input type="number" class="form-control"
           id="durationMinutes" name="durationMinutes"
           min="1" max="1440" step="1" required
           [(ngModel)]="durationMinutes">
  </div>

  <app-edit-event-instructors [instructors]="instructors"
                              [useIsSub]="true"
                              [id]="'editInstructors'"></app-edit-event-instructors>

  <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Cancel
  </button>
  <button type="button" class="btn btn-primary"
          (click)="handleSubmit()">
    Add
  </button>
</div>
